module.exports = __webpack_public_path__ + "1792395595471/fonts/WorkSans-Light.af064db.woff2";